import { createFileRoute } from '@tanstack/react-router';
import { ImporterPanel } from '../../../features/settings/components/ImporterPanel';

/** Unleashed CSV importer (BUILD_SPEC.md §5.9, §2.13) — paste/upload → kind +
 * column mapping → validate (dry-run report) → commit, plus job history.
 * ADMIN only. Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/importer')({
  component: ImporterPanel,
});
